import comp from "./TaggedStudents";
export default comp;
